<template>
    <div id="store-sidebar">
        <div class="right_bottom_corner QQ WX kefuBtn store-sidebar-one" style="bottom:248px;margin-bottom: -100px;">
            <span>业务咨询</span>
            <img src="../../static/img/qiyeweixinIcon.png" style="width: 29px;height: 26px;margin-top: 10px;">
            <img src="../../static/img/thingjsGzh.png" style="height: 170px !important;" alt="" class="thingjsGzh">
        </div>
    </div>
</template>

<script>
    export default {
        name:'infoMenu',
        data() {
            return {

            }
        },
        methods: {
            getUserName(name) {
            if (!name) return null;
            var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
            var arr1, reg1 = new RegExp("(^| )" + 'openid' + "=([^;]*)(;|$)");
            var arr2, reg2 = new RegExp("(^| )" + 'headimgurl' + "=([^;]*)(;|$)");
            if (arr1 = document.cookie.match(reg1)) {
                if (arr = document.cookie.match(reg)) {
                    userpath = '/uploads/wechat/' + unescape(arr1[2]);
                    if (arr2 = document.cookie.match(reg2)) {
                        headimgurl = unescape(arr2[2])
                        //return Base64.decode(unescape(arr[2]));
                        var returnName = '';
                        try {
                            returnName = decodeURI(arr[2]);
                        } catch (error) {
                            return arr[2];
                        }
                        try {
                            var returnName2 = decodeURI(returnName);
                        } catch (error) {
                            return returnName;
                        }
                        return returnName2;
                    }
                } else
                    return null;
                } else {
                    if (arr = document.cookie.match(reg)) {
                        userpath = '/uploads/moni/' + unescape(arr[2]);
                        return unescape(arr[2]);
                    } else
                        return null;
                }
            },
            addQQ(url){
                var iWidth=720;                          //弹出窗口的宽度;
                var iHeight=600;                         //弹出窗口的高度;
                //获得窗口的垂直位置
                var iTop = (window.screen.availHeight - 30 - iHeight) / 2;
                //获得窗口的水平位置
                var iLeft = (window.screen.availWidth - 10 - iWidth) / 2;
                window.open('//shang.qq.com/wpa/qunwpa?idkey=6469ad973d51c06fdc1f92232873e6c18dddb701a1f0dbc2dece2ad9d901f5c3', '_blank', 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',status=no,toolbar=no,menubar=no,location=no,resizable=no,scrollbars=0,titlebar=no');
            },
            // addKf5(url){
            //     var _this=this;
            //     var openid = getCookie("openid");
            //     var userId = getUserName('id');
            //     if (!openid&&userId) {
            //         SSOLOGIN.login();
            //         return;
            //     }
            //     storage.setItem("flag", 'true');
            //     if(userId){
            //         var token = 'Bearer ' + getCookie('accessToken');
            //         $.ajax({
            //             url: 'https://sso.thingjs.com/uinapi/register/kf5?userId=' + userId,
            //             type: 'get',
            //             dataType: 'json',
            //             headers: { 'Authorization': token },
            //             success: function (res) {
            //                 if (res.status == '0') {
            //                     _this.OPENHELP(url,res.data);
            //                 }
            //             },error:function(e) {
            //                 _this.OPENHELP(url);
            //             }
            //         });
            //         return;
            //     }
            //     _this.OPENHELP(url);
            // },
            developmentConsulting(url) {
                var openid = getCookie("openid");
                    if (!openid) {
                        loginwindowon();
                        clearAllCookie();
                        return
                    }
                window.open(url)
            },
            OPENHELP(url,_url) {
                var iWidth = 350;                          //弹出窗口的宽度;
                var iHeight = 478;                         //弹出窗口的高度;
                //获得窗口的垂直位置
                var iTop = (window.screen.availHeight - 30 - iHeight) / 2 + 80;
                //获得窗口的水平位置
                var iLeft = (window.screen.availWidth - 10 - iWidth) / 2 + 696;
                if(_url) {
                    var _open= window.open(_url, '_blank', 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',status=1,toolbar=1,menubar=1,location=1,resizable=1,scrollbars=0,titlebar=1');
                    setTimeout(()=>{
                        _open.location.href=url;
                    //     window.open(url, '_blank', 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',status=1,toolbar=1,menubar=1,location=1,resizable=1,scrollbars=0,titlebar=1');
                        storage.setItem("flag", 'false');
                    },1000);
                } else {
                    window.open(url, '_blank', 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',status=1,toolbar=1,menubar=1,location=1,resizable=1,scrollbars=0,titlebar=1');
                }
            }
        },
    }
</script>

<style lang="less" scoped>
.right_bottom_corner.QQ {
    position: fixed;
    background: #ff8000;
    width: 64px;
    height: 64px;
    bottom: 248px;
    right: 0px;
    text-align: center;
    z-index: 100;
    font-size: 14px;
    line-height: 20px;
    cursor: pointer;
    img {
        width: 40px;
        height: 40px;
        margin-top: 4px;
    }
    span {
        color: #fff;
        position: absolute;
        display: block;
        top: 37px;
        font-size: 12px;
        text-align: center;
        width: 100%;
    }
    .qq-group {
        padding-right: 6px;
        background-color: transparent;
        position: absolute;
        right: 100%;
        bottom: 0;
        width: 290px;
        .qq-group-container {
            display: none;
            background-color: #ffffff;
            border-radius: 3px;
            box-shadow: 0 1px 5px rgba(0, 0, 0, .2), 0 2px 2px rgba(0, 0, 0, .14), 0 3px 1px -2px rgba(0, 0, 0, .12);
            .qq-group-containerdiv {
                display: flex;
                flex-direction: row;
                align-items: center;
                position: relative;
                img {
                    display: block;
                    max-width: 100%;
                    width: auto;
                    height: auto;
                }
                div {
                    h5 {
                        color: #999999;
                        white-space: nowrap;
                        font-weight: normal;
                        margin-top: 0;
                        margin-bottom: 4px;
                        font-size: 15px;
                    }
                    p {
                        color: #CCCCCC;
                        white-space: nowrap;
                        text-align: left;
                        margin-bottom: 0;
                        font-size: 14px;
                    }
                }
                .add-group-btn {
                    display: flex;
                    color: #ff8000;
                    flex-direction: row;
                    align-items: center;
                    border: 1px solid #ff8000;
                    padding: 0 4px;
                    transition: all ease-in-out .3s;
                    border-radius: 3px;
                    position: absolute;
                    right: 8px;
                    top: 22px;
                    .fa-plus {
                        margin-right: .4em;
                        line-height: 1em;
                        width: 1rem;
                        height: 1rem;
                    }
                    &:hover {
                        color: #ffffff;
                        background: #ff8000;
                    }
                }
            }
        }
        &:hover {
            .qq-group-container {
                display: block;
            }
        }
    }
    &:hover {
        img {
            // display: block;
        }
        span,
        .qq-group-container {
            display: block;
        }
    }
}
.thingjsGzh{
    position: fixed;
    bottom:181px;
    right: 88px;
    display: none;
    width: 150px !important;
    height: 150px !important;
}
.WX:hover .thingjsGzh{
    display: block;
}
// 150%弹窗适配
@media screen and (min-width: 770px) and (max-width: 1600px){
    // .store-sidebar-one{
    //     bottom: 166px !important;
    //     // margin-bottom: 0!important;
    // }
    // .store-sidebar-two{
    //     bottom: 98px !important;
    // }
    // .store-sidebar-three{
    //     bottom: 31px !important;
    //     display: none;
    // }
    .thingjsGzh{
        position: fixed;
        bottom:31px;
        right: 88px;
        display: none;
        width: 150px !important;
        height: 150px !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/InfoMenu.vue